import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-terms-of-use-ghana',
    templateUrl: './terms-of-use-ghana.component.html',
    styleUrls: ['./terms-of-use-ghana.component.css'],
})
export class TermsOfUseGhanaComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<TermsOfUseGhanaComponent>) {}

    ngOnInit(): void {}

    close() {
        this.dialogRef.close();
    }
}
